import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import theme from './theme';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Notfound from './pages/Notfound';

function App() {

  const [navbar, setNavbar] = useState(false);
  const [menuSelected, setMenuSelected] = useState('home');

  useEffect(() => {
    if (typeof window.location.pathname !== 'undefined') {
      if (window.location.pathname.replaceAll('/', '') == '') {
        setNavbar(false);
      } else {
        setNavbar(true);
      }
    } else {
      setNavbar(true);
    }

  }, [menuSelected]);

  //const [language, setLanguage] = useState("per");

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>

        {
          navbar ? <Navbar menuSelected={menuSelected} setMenuSelected={setMenuSelected} /> : <Header menuSelected={menuSelected} setMenuSelected={setMenuSelected} />
        }

        <Switch>
          <Route exact path="/" render={(props) => <LandingPage {...props} setMenuSelected={setMenuSelected} />} />
          <Route exact path="/about" render={(props) => <About {...props} setMenuSelected={setMenuSelected} />} />
          <Route exact path="/services" render={(props) => <Services {...props} setMenuSelected={setMenuSelected} />} />
          <Route exact path="/contact" render={(props) => <Contact {...props} setMenuSelected={setMenuSelected} />} />
          <Route exact path="/projects" render={(props) => <Projects {...props} setMenuSelected={setMenuSelected} />} />
          <Route exact path="/projects/:category" render={(props) => <Projects {...props} setMenuSelected={setMenuSelected} />} />

          <Route render={(props) => <Notfound {...props} setMenuSelected={setMenuSelected} />} />
        </Switch>

        {/* <Header />
        <LandingPage /> */}

        <Footer menuSelected={menuSelected} setMenuSelected={setMenuSelected} />

      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
